// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__upv3C","main":"Layout_main__QLnv3","fadeIn":"Layout_fadeIn__u9WmS"};